/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for Spanish language
 *
 * @file es.js
 * @author Manimaran.S
 */

const es = {
  'popularChannelSlider.allChannels': 'Todos los canales',
  'popularChannelSlider.recommended': 'Recomendados',
  'hero.myetextbook.link': 'biblioteca',
  'hero.myetextbook.text': '¿No es el título correcto? Acceda a su libro de texto electrónico',
  'hero.etextfeaturestitle': 'Encuentre materiales de estudio en su libro de texto electrónico',
  'hero.etextfeaturesdescription': 'Su libro de texto electrónico viene con materiales de estudio diseñados para ayudarle a aprender. Estudie con tarjetas didácticas y mucho más directamente en su libro de texto electrónico.',
  'aichat.title1': 'Obtenga ayuda impulsada por IA para cualquier cosa relacionada con este libro de texto electrónico.',
  'aichat.chatDesc1': 'Escriba una pregunta para empezar',
  'subscriptiontext.isSubscribed': 'Parte de su suscripción',
  'subscriptiontext.nonSubscriber': 'Actualice para un acceso completo',
  'topicConatiner.otherHeader': 'Related videos and practice',
  'topicConatiner.exactLiteHeader': 'Related concepts and practice',
  'moremenu.downloadApp': 'Download the app',
  'moremenu.downloadAppAlreadyDownload': '%Click here% para descargar la aplicación en otro dispositivo e iniciar sesión automáticamente o para usar su código QR exclusivo para iniciar sesión de forma segura en la aplicación que ya ha instalado.',
  'moremenu.downloadAppNotDownload': '%Click here% para descargar la aplicación e iniciar sesión de forma segura con su código QR exclusivo',
  'channel.noBundletitle': 'Utilice el paquete de Preparación para el estudio para sus cursos relacionados y otros cursos',
  'onboard.studyPlan': '¡Plan de estudio personalizado creado!',
  'onboard.addCourseAnother': '¿Quiere añadir otro curso?',
  'onboard.purchase': 'Necesito comprar un libro electrónico de Pearson',
  'onboard.addCourseWithoutEtext': 'Añadir curso utilizando Preparación para el estudio',
  'onboard.mayBeLater': 'Quizás luego',
  'onboard.aboutCourse': 'Cuéntenos sobre su curso',
  'onboard.close': 'Cerrar',
  'course.addTitle': 'Añadir curso',
  'common.PURCHASE': 'Comprar',
  'common.CLOSE': 'Cerrar',
  'open': 'abrir',
  'continue': 'Continuar',
  'yes': 'Sí',
  'no': 'No',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': '¡Éxito!',
  'courses.toc.PUBLISH_MESSAGE': 'Los estudiantes verán sus cambios la próxima vez que abran contenido.',
  'errors.GENERIC_TITLE': 'You don\'t have access right now',
  'errors.GENERIC_DESC': 'First, refresh or clear your cache. If that doesn’t work, contact Pearson ',
  'errors.GENERIC_LINK': 'support.',
  'errors.GENERIC_CODE': 'Error code: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Suscripción no encontrada',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Su cuenta no incluye acceso a este título. Si cree que recibió este mensaje por error,\n      comuníquese con el Servicio de Asistencia Técnica de Pearson.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Suscripción no encontrada',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Su suscripción no incluye acceso a eText, sin embargo,\n      puede suscribirse ahora mismo con una tarjeta de crédito.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/?_ga=2.116082310.1845539610.1557867919-NimtqV7BcT00BM9xOXCQUFJYwF3RzEIk',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mi cuenta',
  'menu.helpCenter': 'Centro de asistencia',
  'menu.preferencesCenter': 'Centro de preferencias',
  'menu.CONTACT_SUPPORT': 'Contactar al Servicio de Asistencia Técnica',
  'menu.HELP_SUPPORT': 'Ayuda y soporte',
  'menu.FAQS': 'Preguntas frecuentes',
  'menu.CHAT_WITH_SUPPORT': 'Hable con soporte técnico',
  'menu.OTP_CODES': 'Códigos de OTP',
  'menu.LAUNCH_CODE': 'Iniciar el registro de códigos',
  'menu.SEND_CODE': 'Enviar un código nuevo al usuario por correo electrónico',
  'menu.SEND_CODE_PHONE': 'Enviar un código nuevo al usuario por mensaje de texto',
  'menu.LEGAL': 'Legal',
  'menu.PRIVACY_NOTICE': 'Aviso de privacidad',
  'menu.TITLE_INFO': 'Información del título',
  'menu.PEARSON_ACCESSIBILITY': 'Accesibilidad Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Registre {deviceLimit} dispositivos. Intercambie 1 al mes.',
  'menu.ACCESSIBILITY': 'Accesibilidad',
  'menu.ACCESSIBILITY_SUPPORT': 'Soporte de accesibilidad',
  'menu.DEVICES': 'Dispositivos recientes',
  'menu.THIS_DEVICE': 'Este dispositivo',
  'menu.GET_THE_APP_DOWNLOAD': 'Descargar la aplicación móvil',
  'menu.MOJO_APP_INFO': 'Visite la tienda de aplicaciones en su teléfono inteligente o tableta para usar Pearson+ sin conexión.',
  'menu.DEVICE_LABEL': 'Dispositivo',
  'menu.DEVICE_DISCONNECT': 'Desconectar',
  'menu.FOXIT': 'Potenciado por Foxit',
  'menu.TERMS_OF_USE': 'Términos de uso',
  'menu.SIGN_OUT': 'Cerrar sesión',
  'menu.PRINT_PAGE': 'Imprimir página',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Todos los derechos reservados.',
  'print.FOOTER_MESSAGE': 'Impreso por {fullName}({email}) el {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Ya ha hecho un intercambio este mes',
  'device.SWITCH_DEVICE': '¿Cambiar al dispositivo actual?',
  'device.SWITCH_ONCE': 'Dado que solo puede cambiar una vez al mes, no podrá deshacer esta acción.',
  'device.SEAT_TAKEN': 'Ese asiento está ocupado',
  'device.DISCONNECT_DEVICE': 'Solo puede iniciar sesión en 3 dispositivos. Para continuar aquí, desconecte otro dispositivo.',
  'device.ALERT_TEXT': 'Recuerde que solo puede cambiar los dispositivos una vez al mes.',
  'device.DISCONNECT': 'Desconectar',
  'device.CONTINUE': 'Continuar',
  'device.HEADER': '¿Desea terminar su otra sesión de navegador?',
  'device.CLOSE': 'Regresar a inicio',
  'device.CODE': 'Continue here by entering the authentication code we sent to {maskedEmail}. Not working? Check your spam folder, {email}, or contact {support}.',
  'device.TIMER': 'Tiene {time} para ingresar su código aquí',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Reenviar',
  'device.NOTE': 'If you regularly use Pearson+ in 2 places, like at work and at home, make sure to log out whenever you’re done. You can also use the Pearson+ mobile app on up to 2 devices. For more info, see our {faq}.',
  'device.NOTE_HEADER': 'Avoid this next time',
  'device.CONTACT_SUPPORT': 'Servicio de Asistencia al Cliente',
  'device.CONTACT_EMAIL': 'actualice su dirección de correo electrónico',
  'device.INCORRECT': 'Incorrecto: vuelva a verificar el código o solicite que se le reenvíe.',
  'device.MANY_ATTEMPTS': 'Realizó demasiados intentos, pruebe solicitar el reenvío del código',
  'device.EXPIRED': 'El tiempo ha expirado, pruebe solicitar el reenvío del código',
  'device.ACCESS_HEADER': '¡Ha ingresado!',
  'device.ACCESS_DESC': 'Su sesión se ha autenticado. ¿Quiere aprovechar a actualizar su contraseña?',
  'device.ACCESS_CHANGE_PASSWORD': 'Cambiar contraseña',
  'device.ACCESS_RESET_PASSWORD': 'Restablecer contraseña',
  'device.THREATONE_TITLE': '¿Está todo bien?',
  'device.THREATONE_DESC': '"Notamos una actividad sospechosa en su cuenta."',
  'device.THREATONE_DESC_TWO': 'Este es un buen momento para cambiar su contraseña.',
  'device.MAY_BE_LATER': 'Quizás luego',
  'device.OKAY': 'Aceptar',
  'device.ACCOUNT_LOCK_DESC': 'Por seguridad, cerraremos la sesión. Le enviamos un enlace de restablecimiento de contraseña al correo electrónico asociado con su cuenta.',
  'device.ACCOUNT_LOCK_TITLE': 'Notamos una actividad sospechosa en su cuenta',
  'device.ACCOUNT_LOCK_TIMER': 'La sesión se cerrará en {time}',
  'navigation.PAGE': 'Página',
  'launchcode.CREATEBY': 'Creado por:',
  'launchcode.sentvia': 'Enviado a través de:',
  'launchcode.CODEINLAST': 'Códigos de los últimos siete días:',
  'launchcode.TIMESENT': 'Hora de envío:',
  'launchcode.ACCOUNTEMAIL': 'Correo electrónico de la cuenta:',
  'launchcode.LAUNCHDIALOGTITLE': 'Registro de códigos de OTP',
  'textmessage.TITLE': 'Ingresar número de teléfono',
  'textmessage.PHONE_NUMBER': 'Número de teléfono',
  'textmessage.SEND_CODE': 'Enviar código',
  'textmessage.INVALID_NUMBER': 'El número de teléfono móvil no es válido.',
  'textmessage.SUCCESS_MESSAGE': 'Código enviado',
  'remove.title': '¿Desea eliminar el título?',
  'remove.subTitle': 'Puede volver a recuperarlo más adelante, simplemente utilice la búsqueda para volver a agregarlo.',
  'remove.buttonText': 'Eliminar',
  'search.searchPlaceHolderPPlus': 'Buscar por ISBN, título o autor',
  'search.searchPlaceHolderEText': 'Busque en su biblioteca',
  'footer.downloadMobileApp': 'Descargar la aplicación móvil',
  'footer.termsOfUse': 'Términos de uso',
  'footer.privacy': 'Privacidad',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'No vendan mi información personal',
  'footer.accessibility': 'Accesibilidad',
  'footer.patentNotice': 'Aviso de patente',
  'footer.copyrights': 'Pearson Todos los derechos reservados.',
  'hero.toc.defaultPlacehoder': '--- select a topic ---',
  'hero.openEtextBookV1': 'Abrir el libro electrónico',
  'hero.heroHeading': 'Porque está estudiando <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Preparación para el estudio',
  'hero.study.help': 'Obtenga ayuda para el estudio',
  'hero.study.jumpBackIn': 'Volver a acceder',
  'hero.study.numOfUsers': 'Actualmente, <b>{num_of_users}</b> estudiantes están usando Canales.',
  'hero.heroChannel.cardsHeading': 'Continúe donde se quedó',
  'hero.marketingcard1.copy.title': 'Aprenda con vídeos',
  'hero.marketingcard1.copy.description': 'Vea vídeos explicativos breves en los que se analizan temas complicados.',
  'hero.marketingcard2.copy.title': 'Problemas de práctica',
  'hero.marketingcard2.copy.description': 'Prepárese para su examen con miles de preguntas similares al examen y vídeos con soluciones.',
  'hero.marketingcard3.copy.title': 'Obtenga ayuda experimentada',
  'hero.marketingcard3.copy.description': 'Publique preguntas y reciba respuestas de expertos en el tema.',
  'hero.popularTopics.heading': 'Otros temas populares de este canal',
  'hero.popularChannels.headingv1': '¿Está realizando otro curso?',
  'hero.popularChannels.descriptionv2': 'Explore temas populares de ayuda con el estudio.',
  'hero.practice': 'Practicar',
  'hero.herobook.mappedChannelHeading': 'Ayuda con el estudio recomendada en este canal',
  'libraryL2.myBooks': 'My Books',
  'libraryL2.archived': 'Archivado',
  'libraryL2.back': 'Atrás',
  'hero.practiceProblem': 'Practice Problem',
  'nativeAppBanner.drawer.title': 'Open in ...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+ App',
  'nativeAppBanner.banner.title': 'Pearson+ app',
  'nativeAppBanner.banner.description': 'Learn on the go',
  'hero.promotionalcard.list1': 'Vea vídeos tutoriales en los que se analizan temas complicados',
  'hero.promotionalcard.list2': 'Miles de preguntas similares al examen',
  'hero.promotionalcard.list3': 'Reciba respuestas de expertos en el tema',
  'hero.studyandexamprep': 'Preparación para el estudio',
  'hero.heroBook.sectionSubHeadingV1': 'Profundice en los distintos temas con explicaciones en vídeo y preguntas de práctica adaptadas a su curso.',
  'hero.heroBook.sectionSubHeadingV2': 'Profundice en los distintos temas con explicaciones de conceptos y preguntas de práctica adaptadas a su curso.',
  'hero.SeeAllStudyOptions': 'See all study options',
  'hero.herobook.mappedChannelHeadingV1': 'Recommended videos and practice questions',
  'hero.popularTopics.headingV1': 'Otros temas populares',
  'hero.heroHeadingV1': 'For <span>{replace_value}</span>',
  'hero.learnmore': 'Leer más',
  'hero.eTextbook': 'Libro electrónico',
  'hero.goToPage.label': 'Ir a la página',
  'subscription.studyTitle': 'Preparación para el estudio',
  'print.printAvailTitle': '¿Quiere imprimir esta página? Así puede',
  'print.printAvailDesc': 'En su libro de texto electrónico, seleccione el icono de cuenta en la parte superior derecha. Desde las opciones, elija "Imprimir página" y luego escoja sus ajustes de impresión.',
  'print.printNotAvailTitle': 'The print option for this eText is not enabled.',
  'print.printNotAvailDesc': 'For convenient offline access, please download your title through the Pearson+ mobile app and enjoy the flexibility of studying anytime, anywhere!',
  'hero.header.cta': 'Go to study tools',
  'hero.header.ctav2': 'Abrir Preparación para el estudio',
  'hero.marketing.title': 'Encuentre su libro electrónico',
  'hero.marketing.subTitle': 'Elija entre más de 2000 libros electrónicos con audios, tarjetas didácticas, notas y más. Todo por tan solo 10,99 $/mes por cuatrimestre.',
  'hero.popularchannels.desc': 'Obtenga ayuda para el estudio de estas asignaturas principales',
  'hero.removecourse.title': '¿Eliminar el curso del Tablero?',
  'hero.removecourse.description': 'Siempre puede volver a añadir este curso a su tablero haciendo clic en "Añadir curso".',
  'hero.removecourse.primaryCtaText': 'Eliminar',
  'hero.removecourse.secondaryCtaText': 'Cancelar',
  'hero.tableOfContents': 'Índice',
  'hero.search': 'Buscar',
  'hero.emptystate.cta': 'Buscar libros de texto electrónicos',
  'hero.watch_it_again': 'Vuelva a verlo',
  'hero.mondly.learnLang.title': 'Aprenda un nuevo idioma gratis',
  'hero.mondly.subTitle': 'Los usuarios de libros de texto electrónicos de Pearson obtienen tres meses gratis de Mondly de Pearson.',
  'hero.mondly.description': 'Most language learning apps only let you learn from English. But it\'s best to learn from your native language, so Mondly allows you to learn from any of our <strong>41 languages</strong>.',
  'hero.mondly.startLearningCTA': 'Comenzar a aprender',
  'hero.mondly.marketing.bestApp': 'Best App',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'App of the Year',
  'hero.mondly.marketing.fbStart': 'Facebook FbStart - 2017 EMEA Winner',
  'hero.mondly.marketing.editorChoice': 'Editor Choice',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Aprenda un idioma',
  'header.menu.moreAtPearson': 'Más en Pearson',
  'hero.subscriptionStatusTitle2': 'Sus recursos de Pearson+',
  'hero.startStudying': 'Comenzar a estudiar',
  'onboard.studyMaterials': 'Seleccione su materia y crearemos un tablero con material de estudio personalizado.',
  'hero.myETextbooks': 'Mis libros electrónicos',
  'header.continueInTheApp': 'Continuar en la aplicación',
  'hero.learnTxt': 'Aprender',
  'hero.examPrepTxt': 'Preparación para exámenes',
  'hero.aITutorTxt': 'Tutor con IA',
  'AI.toolTip': 'Pregúnteme cualquier cosa de su libro de texto electrónico',
  'hero.studyExamPrepAllYourCourses': 'Preparación para el estudio para todos sus cursos',
  'header.qrCode.subHeaderTxt': 'Use este código QR para iniciar sesión de forma rápida y segura en la aplicación Pearson+ de su dispositivo móvil.',
  'header.qrCode.dontHaveApp': '¿No tiene la aplicación?',
  'header.qrCode.footerTxt': 'Escaneando este código, se le redirigirá a la App Store o a Google Play. Después de haber descargado la aplicación, inicie sesión escaneándolo de nuevo.',
  'header.qrCode.errorMsg': 'No se cargó el código QR. Cierre e intente nuevamente.',
  'hero.yourETextbook': 'Su libro de texto electrónico.',
  'onboard.addCourseWithEtextBundle': 'Añadir curso utilizando Preparación para el estudio',
  'onboard.disableTooltipText': '¡Se han añadido todos los cursos de Preparación para el estudio!',
  'subscriptionstatus.bundlecta': 'Acceso a Preparación para el estudio',
  'subscriptionstatus.nonbundlecta': 'Acceso a Preparación para el estudio',
  'channel.genericBundle': 'Utilice Preparación para el estudio para sus otros cursos',
  'channel.relatedBundle': 'Utilice también Preparación para el estudio para sus otros cursos',
  'onboard.courseAdded': '¡Curso añadido!',
  'hero.flashcards': 'Tarjetas didácticas',
  'relatedChannelCard.title': 'Impulse su aprendizaje con este recurso relacionado',
  'relatedChannelCard.badgeText': 'Relacionado con Preparación para el estudio',
  'sessionInactivity.title': '¿Sigue ahí?',
  'sessionInactivity.description': 'Your session will time out in <b>%TIMER%</b> due to inactivity.<br/>Would you like to stay signed in?',
  'sessionInactivity.keepMeSignIn': 'Mantenme conectado',
  'sessionInactivity.signOut': 'Cerrar sesión',
  'sessionTimeout.title': 'Sesión expirada',
  'sessionTimeout.description': 'Su sesión ha expirado por inactividad.',
  'print.qrCode.header': 'Use este código QR para abrir la aplicación Pearson+ en su dispositivo móvil.',
  'print.qrCode.footer': 'Al escanear este código, se le redirigirá a la App Store o a Google Play. Después de haber instalado la aplicación, inicie sesión para descargar y acceder a su título.',
  'hero.nestest.title': 'Prepare for your teacher certification exam',
  'hero.nestest.subTitle': 'Pearson+ users can now access nationally aligned preparation courses and practice tests to prepare for their teacher certification exams.',
  'hero.channelAI.title': '¿Necesita ayuda? El Tutor con IA está aquí para ayudarle.',
  'hero.channelAI.desc': 'Haga una pregunta y obtenga ayuda paso a paso con los deberes, recomendaciones de estudio y más. Ayuda personalizada siempre que la necesite.',
  'hero.channelAI.action': 'Pregunte a su Tutor con IA ahora',
  'new': '¡Nuevo!',
  'hero.practice.numOfUsers': 'This section has <b>{practice_num_of_users}</b> practice problems.',
  'hero.practice.cta': 'Practice now',
  'hero.practice.title': 'Practice problem',
  'diagnostics.errorMsg': 'No se cargó el diagnóstico. Cierre e inténtelo nuevamente',
  'qrcode.title': 'Start studying anywhere',
  'qrcode.subtitle': 'Learn anywhere, anytime with the Pearson+ mobile app. Download now and unlock a seamless learning experience.',
  'qrcode.detailsv1': 'With the Pearson+ app, you can use this QR code to pick up where you left off. Search your book, study with flashcards, watch video lessons, and more wherever you go.',
  'qrcode.detailsv2': 'Scan this QR code whenever you want to log in quickly and pick up right where you left off.',
  'qrcode.details': 'With the Pearson+ app, you can use this QR code to pick up where you left off.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Learn anywhere, anytime with the Pearson+ mobile app. Download now and unlock a seamless learning experience.',
  'install': 'Install',
  'header.menu.createCourse': 'Nuevo curso',
  'header.dropdown.courses': 'Cursos',
  'header.dropdown.recentlyViewed': 'Visto recientemente',
  'header.dropdown.viewAll': 'Ver todos los cursos',
  'aet.courseHeader.inviteStudents': 'Invitar a estudiantes',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invite a estudiantes a acceder a este libro de texto electrónico copiando la dirección del enlace o las instrucciones indicadas a continuación en su correo electrónico o temario.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copiar enlace',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instrucciones con la dirección del enlace',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copiar las instrucciones',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Se le pedirá que inicie sesión con su cuenta de Pearson. Si no tiene una cuenta de Pearson, podrá crearla.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Fecha de inicio:',
  'aet.courseHeader.endDate': 'Fecha de finalización:',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Formato:',
  'aet.home.manageroster': 'Gestionar la lista de estudiantes',
  'aet.home.managegradesync': 'Gestionar la sincronización de calificaciones',
  'aet.home.copycourse': 'Copiar curso',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Actual',
  'aet.instructorCourse.tabs.past': 'Anterior',
  'aet.instructorCourse.tabs.courseSettings': 'Ajustes del curso',
  'aet.instructorCourse.tabs.manageRoster': 'Gestionar la lista de estudiantes',
  'aet.instructorCourse.currentCourses.title': 'Cursos actuales',
  'aet.instructorCourse.pastCourses.title': 'Cursos pasados',
  'aet.instructorCourse.createOrCopy.title': 'Crear o copiar un curso',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copie un curso de otro instructor o cree uno nuevo',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copiar un curso de otro instructor',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Introduzca el ID del curso para encontrar el curso que quiere copiar.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Introduzca el ID del curso',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Ha buscado',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Crear un nuevo curso a partir del catálogo',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Busque por título, autor, ISBN o palabras claves sobre el tema.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Buscar...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Mostrar más',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Mostrar menos',
  'aet.instructorCourse.cancel': 'Cancelar',
  'aet.instructorCourse.loading': 'Cargando...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Sincronización de calificaciones',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Gestionar la sincronización de calificaciones',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nombre del curso',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nombre de la sección',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sin título',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institución',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'La institución es obligatoria',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Algo salió mal. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'No se encontraron resultados',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Fecha de inicio del curso',
  'aet.instructorCourse.courseForm.endDateLabel': 'Fecha de finalización del curso',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Permitir que otros copien este curso',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Comparta este código con los instructores que quieren copiar este curso',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copiar código',
  'aet.instructorCourse.courseForm.optionalSuffix': '(opcional)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'El formulario presenta errores de validación',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuar',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Guardando...',
  'aet.instructorCourse.courseForm.submitError': 'No hemos podido crear su curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitEditError': 'No hemos podido guardar sus cambios. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Guardar cambios',
  'aet.instructorCourse.courseForm.materialsHeader': 'Materiales del curso',
  'aet.instructorCourse.courseForm.resolveError': 'No hemos podido cargar los materiales del curso. Inténtelo de nuevo.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Últimos vistos',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Añadido recientemente',
  'aet.instructorCourse.coursesSort.aToZ': 'De la A a la Z',
  'aet.instructorCourse.coursesSort.zToA': 'De la Z a la A',
  'aet.instructorCourse.manageRoster.column.name': 'Nombre',
  'aet.instructorCourse.manageRoster.column.role': 'Función',
  'aet.instructorCourse.manageRoster.column.email': 'Correo electrónico',
  'aet.instructorCourse.manageRoster.column.status': 'Estado',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Estudiante',
  'aet.instructorCourse.roster.role.ta': 'AD',
  'aet.instructorCourse.roster.role.instructor': 'Instructor',
  'aet.instructorCourse.roster.status.active': 'Activo',
  'aet.instructorCourse.roster.status.inactive': 'Inactivo',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Todos los miembros',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Estudiantes activos',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Estudiantes inactivos',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Ayudante docente',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Instructor',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Autor:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Fecha de creación del curso:',
  'aet.instructorCourse.noCoursesFound': 'No se encontraron cursos',
  'aet.instructorCourse.backButton': 'Atrás',
  'aet.instructorCourse.selectCourse': 'Seleccionar un curso',
  'aet.home.linkedToLms': 'Vinculado con LMS',
  'aet.instructorCourse.courseForm.title.create': 'Crear curso',
  'aet.instructorCourse.courseForm.title.copy': 'Copiar curso',
  'aet.instructorCourse.courseForm.title.edit': 'Información del curso',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Tareas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenido de la tarea',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Fecha de entrega de las tareas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Aspectos destacados y notas',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Color de resaltador',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texto de la nota',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Estado compartido',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Lista de estudiantes y participación',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Nombres de los estudiantes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Direcciones de correo electrónico',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inscripciones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Finalización y conclusiones',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Ajustes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Datos copiados',
  'aet.studentRoster.manageStudentRosterButton': 'Gestionar la lista de estudiantes',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Exportar progreso de los estudiantes',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Estado:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscrito:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Función:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'Como ayudante docente, esta persona podrá ver el progreso y el rendimiento de todos los estudiantes de esta clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'También podrá gestionar a los estudiantes y las tareas, pero no podrán eliminar la clase.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promover a ayudante docente',
  'aet.home.manageRoster.searchPlaceholder': 'Buscar estudiante',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inactivar los estudiantes seleccionados',
  'aet.home.manageRoster.FilterLabel': 'Mostrar',
  'aet.home.manageRoster.updatingMessage': 'Actualizando la lista de estudiantes... Esto podría tardar unos minutos.',
  'aet.home.courses.search.searchPlaceHolder': 'Buscar sus cursos',
  'aet.courses.emptyStateDescription': 'Comience a construir su curso eligiendo una de las siguientes opciones.',
  'nativePromoBanner.continueInBrowser': 'Continue in browser',
  'globalnav.tooltip.hideNavText': 'Hide navigation',
  'globalnav.tooltip.showNavText': 'Show navigation',
  'aet.syllabus.progressTitle': 'Extrayendo...',
  'aet.syllabus.progressDesc': 'Espere un momento mientras procesamos su temario.',
  'aet.syllabus.uploadInputLabel': 'Arrastre y suelte sus archivos o haga clic para subirlos',
  'aet.syllabus.uploadSyllabusTabLabel': 'Cargar temario',
  'aet.syllabus.dateAdjusterTabLabel': 'Ajustador de fecha',
  'aet.syllabus.addManuallyTabLabel': 'Añadir manualmente',
  'aet.syllabus.addEditLaterText': 'Siempre puede añadir y editar tareas posteriormente',
  'aet.syllabus.editAssignmentLabel': 'Editar tarea',
  'aet.syllabus.addAssignmentLabel': 'Añadir tarea',
  'aet.syllabus.assignmentTitleLabel': 'Título de la tarea',
  'aet.syllabus.dueDateLabel': 'Fecha de entrega',
  'aet.syllabus.editDueDateLabel': 'Edit due date',
  'aet.syllabus.chaptersCoveredLabel': 'Seleccione los capítulos o secciones que tratar.',
  'aet.syllabus.updateCtaLabel': 'Actualizar tarea',
  'aet.syllabus.addCtaLabel': 'Añadir tarea',
  'aet.syllabus.uploadLabel': 'Cargar',
  'aet.syllabus.confirmLabel': 'Confirmar',
  'aet.syllabus.updateDatesLabel': 'Actualizar fecha',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': '¿Eliminar tarea?',
  'aet.deleteAssignmentTitleMultiple': '¿Eliminar tareas?',
  'aet.deleteAssignmentWarning': 'Esta acción no puede deshacerse y todas las entregas asociadas y los datos de estudiante ya no serán visibles.',
  'aet.deleteAssignmentKeepCTA': 'Mantener tarea',
  'aet.deleteAssignmentDeleteCTA': 'Eliminar',
  'aet.assignments.loadingAsset': 'Cargando activo...',
  'aet.assignments.allCaughtUpDescription': 'No hay tareas previstas para esta semana.',
  'aet.assignments.progressTitle': 'Progreso',
  'aet.assignments.performanceTitle': 'Confianza',
  'aet.assignments.completionTitle': 'Finalización',
  'aet.assignments.statusTitle': 'Estado',
  'aet.assignments.addTooltip': 'Añadir tarea',
  'aet.assignments.deleteTooltip': 'Eliminar tareas seleccionadas',
  'aet.assignments.selectToDeleteLabel': 'Modo seleccionar y eliminar',
  'aet.assignments.bulkEditTooltip': 'Editar tareas en lote',
  'aet.assignments.title': 'Tareas',
  'aet.assignments.assignmentTitle': 'Tarea',
  'aet.assignments.dueDate': 'Fecha de entrega',
  'aet.tabular.searchPlaceholder.assignments': 'Search assignments',
  'aet.tabular.searchPlaceholder.students': 'Search students',
  'aet.tabular.searchPlaceholder.questions': 'Search questions',
  'aet.assignemnts.columnDueDateInfoTooltip': 'One or more students have due date extensions for all assignments',
  'aet.assignemnts.singleDueDateInfoTooltip': ' One or more students have due date extensions for this assigment',
  'aet.assignemnts.masterDueDateInfoTooltip': 'One or more students have been granted due date extensions. Look for the Info icon to identify these assignments.',
  'aet.home.loading': 'Cargando...',
  'aet.home.errorFetchingAssignments': 'Error al recuperar las tareas',
  'aet.home.dueThisWeekTitle': 'Para esta semana',
  'aet.home.allCaughtUpTitle': '¡No hay nada pendiente!',
  'aet.home.allCaughtUpDescription': 'No hay tareas previstas para esta semana.',
  'aet.home.suggestedRemediationTitle': 'Suggested review by Study Prep',
  'aet.home.noSuggestedRemediationTitle': 'No se sugiere ningún material de repaso',
  'aet.home.noSuggestedRemediationDescription': 'Vuelva a comprobar después de su siguiente tarea.',
  'aet.home.assignmentIncludesTitle': 'La tarea incluye',
  'aet.home.sectionsLabel': 'Chapter(s)',
  'aet.home.questionsCount': '{count} preguntas',
  'aet.home.dueLabel': 'Due: {dueDate}',
  'aet.home.due': 'Vence:',
  'aet.home.progressCompletedLabel': 'Completado',
  'aet.home.progressCompletedPastDueLabel': 'Completado vencido',
  'aet.home.progressInProgressLabel': 'En progreso',
  'aet.home.progressNotStartedLabel': 'Sin comenzar',
  'aet.home.progressCountOfTotal': '{count} of {total}',
  'aet.home.NotAttemptedLabel': 'Sin intentar',
  'aet.home.questionsTotalLabel': 'Preguntas totales',
  'aet.home.progressCompletedOnTimeLabel': 'Completado a tiempo',
  'aet.home.segmentGreatLabel': 'Genial',
  'aet.home.segmentGettingThereLabel': 'Aceptar',
  'aet.home.segmentNeedsReviewLabel': 'Necesita trabajo',
  'aet.home.segmentOkayLabel': 'Aceptar',
  'aet.home.editAssignmentTooltip': 'Editar tarea',
  'aet.home.deleteAssignmentTooltip': 'Eliminar tarea',
  'aet.home.viewDetailsButton': 'Ver detalles',
  'aet.home.viewAsStudentButton': 'Ver como estudiante',
  'aet.home.welcomeButtonText': 'Comenzar →',
  'aet.review.emptyStateTitle': 'Nada que repasar',
  'aet.review.emptyStateDescription': 'Vuelva a comprobar después de su siguiente tarea.',
  'aet.dashboard.tabs.upNext': 'A continuación',
  'aet.dashboard.tabs.welcome': 'Bienvenido',
  'aet.dashboard.tabs.assignments': 'Tareas',
  'aet.dashboard.tabs.review': 'Revisar',
  'aet.dashboard.tabs.studentRoster': 'Estudiantes',
  'aet.dashboard.classSchedule': 'Calendario de clases:',
  'aet.syllabus.dueTimeLabel': 'Plazo de entrega',
  'hero.accessEducatorGuides': 'Acceder a las guías para educadores',
  'aet.assignment.save': 'Guardar',
  'aet.assignment.saveAndAdd': 'Guardar y añadir otro',
  'aet.assignment.delete': 'Eliminar',
  'aet.assignment.saveAndClose': 'Guardar y cerrar',
  'aet.studentRoster.title': 'Estudiantes',
  'aet.studentRoster.titlev1': 'Estudiante',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Due dates',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Estándar',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 days',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 days',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 days',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 week',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 weeks',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Last day of class',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Past-due assignments couldn\'t be updated automatically. Edit each one to set a new due date.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Unable to update due dates',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due and couldn\'t be updated automatically. Edit each one to set a new due date.',
  'aet.bulkEdit.bulkSplitInstruction': 'Dividiremos sus tareas de manera uniforme.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Primera tarea a entregar',
  'aet.bulkEdit.lastAssignmentDue': 'Última tarea a entregar',
  'aet.bulkEdit.assignmentsDueDays': '¿En qué días quiere que se entreguen las tareas?',
  'aet.bulkEdit.addEditLaterText': 'Utilizamos IA para crear tareas. Siempre puede añadir y editar tareas posteriormente.',
  'aet.bulkEdit.monday': 'Lunes',
  'aet.bulkEdit.tuesday': 'Martes',
  'aet.bulkEdit.wednesday': 'Miércoles',
  'aet.bulkEdit.thursday': 'Jueves',
  'aet.bulkEdit.friday': 'Viernes',
  'aet.bulkEdit.saturday': 'Sábado',
  'aet.bulkEdit.sunday': 'Domingo',
  'aet.toast.assignmentCreated.title': '¡Tarea creada!',
  'aet.toast.assignmentCreated.single': 'Se le ha puesto automáticamente el nombre {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} tareas se han creado',
  'aet.toast.assignmentUpdated.title': 'Updated successfully.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} se ha actualizado',
  'aet.toast.assignmentUpdated.multiple': '{count} assignments have been updated',
  'aet.toast.viewAssignment': 'Ver tarea',
  'aet.toast.viewAssignments': 'Ver tareas',
  'aet.welcome.title': 'Su libro de texto electrónico de Pearson ahora está vinculado a su curso LMS',
  'aet.welcome.LMSAccounTitle': 'Explorar progreso del estudiante',
  'aet.welcome.LMSAccounDescription': 'Descubra exactamente con qué temas tiene dificultades su clase.',
  'aet.welcome.createAssignmentsTitle': 'Crear tareas',
  'aet.welcome.createAssignmentsDescription': 'Asigne capítulos manualmente o subiendo su temario.',
  'aet.welcome.progressViewTitle': 'Realice un seguimiento del rendimiento en su LMS',
  'aet.welcome.progressViewDescription': 'Elija la configuración de sincronización de calificaciones en su curso LMS.',
  'aet.assignmentDetails.noAssignmentFound': 'No se encontraron tareas',
  'aet.assignments.loadingErrorTitle': 'La tarea no puede cargarse ahora mismo',
  'aet.assignments.loadingErrorDescription': 'Pruebe a actualizar la página o vuelva a comprobarlo más tarde.',
  'aet.assignmentStudentDetails.noDataFound': 'Aún no hay datos',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'No hay estudiantes registrados.',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Los estudiantes se unirán a su clase cuando compren el libro de texto electrónico.',
  'aet.home.editAssignmentTooltipDisabled': 'No se puede editar: trabajo de estudiante en curso',
  'aet.home.deleteAssignmentTooltipDisabled': 'No se puede eliminar: trabajo de estudiante en curso',
  'aet.home.StudentDetails.questions': 'Preguntas',
  'aet.home.StudentDetails.attempts': 'Intentos',
  'aet.home.StudentDetails.comprehension': 'Confianza',
  'hero.titleInfo.tooltip': 'Información del título',
  'aet.home.publishAssignments': 'Publicar todas las tareas',
  'aet.dashboard.footer': 'Algunos contenidos se han creado utilizando IA basándose en los materiales de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, aun así la IA generativa podría producir información inexacta sobre personas, lugares o hechos.',
  'aet.home.bulkEditTitle': 'Editar tareas en lote',
  'aet.home.bulkEditSubtitle': 'Realice los cambios en su temario y luego vuelva a subirlo aquí. Sus tareas y fechas de entrega se actualizarán para que coincidan.',
  'aet.home.createAssignmentTitle': 'Crear tareas',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Incluido en otra tarea',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Algunas secciones se incluyen en otra tarea',
  'aet.welcome.welcome.Title': '¡Bienvenido!',
  'aet.home.student.roaster.ProgressTitle': 'Completado total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Vuelva a comprobar cuando los alumnos hayan empezado la tarea.',
  'aet.home.whatDueThisWeekTitle': 'Esto es lo que vence esta semana',
  'aet.assignments.edit.errorTitle': '{count} tareas tienen errores',
  'aet.assignments.edit.errorSubTitle': 'Las tareas con errores no pueden publicarse. Edítelas o publíquelas sin ellos.',
  'aet.assignments.edit.publishAnyway': 'Publicar de todos modos',
  'aet.assignments.edit.editAssignments': 'Editar tareas',
  'aet.assignments.edit.validationInfoToolTip': 'Editar tarea para eliminar errores',
  'aet.assignments.error.assignmentCreated.title': 'Todas las tareas tienen errores',
  'aet.assignments.error.assignmentCreated.description': 'Las tareas con errores no pueden publicarse. Edítelas o pruebe con un temario diferente.',
  'aet.assignments.error.uploadSyllabus': 'Cargar temario',
  'aet.assignments.error.editAssignments': 'Editar tareas',
  'aet.mondly.title': 'Idiomas',
  'aet.studentRoster.errorState.title': 'Lista de estudiantes no disponible',
  'aet.studentRoster.errorState.description': 'No hemos podido cargar su lista de estudiantes. Pruebe a actualizar la página o vuelva a comprobarlo más tarde.',
  'aet.assignments.sectionLabel': 'sección(es)',
  'aet.assignments.questionsLabel': 'pregunta(s)',
  'aet.assignments.assignmentsLabel': 'tarea(s)',
  'aet.assignments.performanceProgressBar': 'Barra de progreso de desempeño',
  'aet.assignments.completionProgressBar': 'Barra de progreso de finalización',
  'aet.syllabus.deleteConfirmationSubtitleSingle': '¿Seguro que quiere eliminar esta tarea?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': '¿Seguro que quiere eliminar estas tareas?',
  'aet.home.nextAssignmentTitle': 'Siguiente tarea',
  'aet.home.courseSettings': 'Ajustes del curso',
  'aet.home.pearsonETextbookResources': 'Recursos del libro de texto electrónico de Pearson+',
  'aet.home.etextbookInformation': 'Información sobre el libro de texto electrónico',
  'aet.multiple.deleteAssignmentKeepCTA': 'Mantener tarea(s)',
  'aet.syllabus.processingText.header': 'Estamos organizando las lecturas asignadas para su clase, solo nos llevará un momento.',
  'aet.syllabus.processingText.uploading': 'Cargando su documento',
  'aet.syllabus.processingText.activating': 'Activando componentes de IA',
  'aet.syllabus.processingText.extracting': 'Extrayendo las tareas de lectura',
  'aet.syllabus.processingText.mapping': 'Correspondencia con el contenido del libro de texto',
  'aet.syllabus.processingText.finishing': 'Terminando',
  'aet.syllabus.uploadErrorMessage': 'Asegúrese de que su PDF o .docx sea de menos de 10MB y que su conexión a internet sea estable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Intentar de nuevo',
  'aet.syllabus.selectChapterWithQuestions': 'Seleccione un capítulo con pregunta(s).',
  'preferenceSetting.subTitle': 'Estos ajustes serán los predeterminados para todos los estudiantes de este curso.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interacciones con IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Habilitar la herramienta de estudio con IA y los resúmenes con IA en los resultados de búsqueda',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Mostrar los recursos de Preparación para el estudio relacionados con este libro',
  'aet.syllabus.footer': 'La creación de tareas está impulsada por IA',
  'aet.dashboard.footerDialogDeatils': 'Se utiliza IA generativa para crear preguntas sobre tareas basadas en los materiales de aprendizaje de Pearson. Aunque Pearson cuenta con un proceso para validar el resultado, aun así la IA generativa podría producir información inexacta sobre personas, lugares o hechos. También se utiliza IA para agrupar contenido en tareas, basándose en el temario y/o programación que usted proporcione.',
  'aet.review.footer': 'Creado utilizando IA',
  'aet.footerCard.dismiss': 'Descartar',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Preparación para el estudio es una herramienta adicional que ayuda a aprender ofreciendo a los estudiantes vídeos y problemas de práctica adaptados a ese curso.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Puede que a los estudiantes cuyo plan de acceso no incluya Preparación para el estudio se les pida suscribirse para continuar utilizando recursos de Preparación para el estudio.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Los estudiantes que ya hayan adquirido Preparación para el estudio no se verán afectados por esta configuración.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Descubra más sobre las ventajas de Preparación para el estudio',
  'aet.home.viewCourseId': 'Ver el ID del curso',
  'aet.home.copy': 'Copiar',
  'aet.home.copied': 'Copiado',
  'aet.home.courseLabel': 'ID del curso:',
  'schoolInfoCard.addUniversity': 'Add school',
  'schoolInfoCard.title': 'Información sobre el centro de estudios',
  'schoolInfoCard.titleV1': 'Cuéntenos sobre su curso',
  'schoolInfoCard.cta': 'Comenzar',
  'schoolInfoCard.pickInstitution': 'Pick school',
  'schoolInfoCard.addUniversityTitle': 'Añada su escuela',
  'schoolInfoCard.addUniversitySubtitle': 'Conocer su centro de estudios y curso nos permite recomendarle los materiales de estudio más útiles.',
  'schoolInfoCard.searchPlaceholder': 'Busque su centro de estudios...',
  'schoolInfoCard.skip': 'Omitir este paso',
  'schoolInfoCard.nextStep': 'Próximo paso',
  'schoolInfoCard.notInList': 'Mi centro de estudios no está en la lista',
  'schoolInfoCard.noResults': 'No se han encontrado centros de estudios que coincidan con su búsqueda',
  'schoolInfoCard.noResultsHeading': '¿No encuentra su centro de estudios?',
  'schoolInfoCard.noResultsInstruction': 'Introduzca el nombre completo a continuación',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nombre de la escuela',
  'schoolInfoCard.addInstitutionLabel': 'Añadir esta escuela',
  'aet.assignments.assignmentTitlePlaceholder': 'Introduzca un título',
  'aet.assignments.titleValidation.titleRequired': 'El título de la tarea es obligatorio.',
  'aet.assignments.titleValidation.titleTooLong': 'El título de la tarea no puede tener más de {0} caracteres.',
  'aet.assignments.titleValidation.titleInvalidChar': 'El título de la tarea contiene caracteres no admitidos.',
  'aet.assignments.titleValidation.titleDuplicate': 'El título de la tarea ya existe',
  'aet.syllabus.timeZoneLabel': 'Huso horario',
  'aet.review.reviewReadingFromAssignments': 'Revisar mediante la lectura de la tarea',
  'aet.assignments.chaptersLabel': 'chapter(s)',
  'menu.myAccount.subTitle': 'Your institution lives here',
  'menu.myAccount.subTitleNotAvailable': 'You can add the institution here later anytime.',
  'schoolInfoCard.toastMessage': 'University saved',
  'aet.review.threeDotMenu.askAI': 'Preguntar a la IA',
  'aet.home.suggestedRemediationSubtitle': 'Watch relevant videos and practice to master your course topics.',
  'aet.home.laggedQuestionLabel': 'Preguntas marcadas',
  'aet.home.correctAnswer': 'Respuesta correcta',
  'aet.home.incorrectAnswer': 'Respuesta incorrecta más común',
  'aet.home.behaviourTrendsLabel': 'Información sobre la pregunta',
  'aet.home.strugglingStudentsLabel': 'Estudiantes con dificultades',
  'aet.home.patternsInStudensAiLabel': 'Patrones de uso de la IA por parte de los estudiantes',
  'aet.home.questionLabel': 'Pregunta',
  'aet.home.studentAskingSimilarQuestions': 'Estudiantes haciendo preguntas similares',
  'aet.home.assignmentDifficultQuestions': 'Preguntas difíciles',
  'aet.home.behaviorTrends': 'Información sobre la pregunta',
  'aet.home.behaviors': 'Indicadores de desempeño',
  'aet.home.mostDifficultTopics': 'Most difficult questions',
  'aet.home.commentsFromStudentLabel': 'Comentarios de estudiantes',
  'aet.home.disregard': 'Ignorar',
  'aet.home.reportAsInaccurate': 'Informar de inexactitud',
  'aet.home.Flagged': 'Marcado',
  'aet.home.reportQuestionTitle': 'Informar un error en la pregunta',
  'aet.home.reportQuestionLabel': '¿Qué había de malo en esa pregunta?',
  'aet.home.showComments': 'Mostrar comentarios',
  'aet.home.studentReports': 'informes de estudiante',
  'aet.home.placeholderText': 'Por favor, explique...',
  'aet.home.reportQuestion.notRelevant': 'No relevante',
  'aet.home.reportQuestion.notCorrect': 'No es correcta',
  'aet.home.reportQuestion.unsafe': 'Unsafe/Harmful',
  'aet.home.reportQuestion.somethingElse': 'Otra cosa',
  'aet.home.StudentDetails.assistedByAI': 'Con la ayuda de la IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Ningún estudiante tiene dificultades ahora mismo',
  'aet.home.strugglingStudents.emptyStateDescription': 'Vuelva a comprobarlo más tarde.',
  'aet.home.overallStatus.excelling': 'Destacado',
  'aet.home.overallStatus.fallingBehind': 'Atrasado',
  'aet.home.overallStatus.keepingUp': 'Keeping up',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Show only "Difficult questions"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Show only "Struggling students"',
  'aet.home.viewQuestionInAssignment': 'View question in assignment',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Incorrect first attempts',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Multiple incorrect attempts',
  'aet.home.insightRisk.lowConfidence': 'Low confidence',
  'aet.home.insightRisk.mediumConfidence': 'Medium confidence',
  'aet.home.insightRisk.lowEngagement': 'Low engagement',
  'aet.home.insightRisk.countOfStudents': '{count} of {total} students',
  'aet.home.insightRisk.na': 'N/A',
  'aet.home.strugglingStudentsHereLabel': 'Students struggling here',
  'aet.home.insightRisk.didNotAttempt': 'Did not attempt',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default es;
